var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Person_ico",
    "data-name": "Person ico",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6679",
    "data-name": "Rect\\xE1ngulo 6679",
    width: 36,
    height: 36,
    transform: "translate(0 -4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-person-6733745",
    transform: "translate(-6.178 0.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15559",
    "data-name": "Grupo 15559",
    transform: "translate(14.933 1.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9543",
    "data-name": "Trazado 9543",
    d: "M26.113,21.447l-5.854,5.845a1.078,1.078,0,0,1-1.845-.759V23.947a7.992,7.992,0,0,0-6.44,4.009l-.164.285h0a1.07,1.07,0,0,1-.931.543,1.087,1.087,0,0,1-.285-.043,1.061,1.061,0,0,1-.8-1.035v-.983a9.287,9.287,0,0,1,8.621-9.251V14.825a1.087,1.087,0,0,1,1.845-.759l5.854,5.854a1.079,1.079,0,0,1,0,1.526Z",
    transform: "translate(-8.866 -9.308)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e4071af41693e0bb3823048d4476f436.svg";
export { ForwardRef as ReactComponent };